import { Link } from "react-router-dom"
import { toSalusionPrivate } from "../../util"
import Lottie from "lottie-react"

import animationHero from "../../lottie/salutions-hero.json"
import { Helmet } from "react-helmet-async"

export default function Hero() {
	// const organizationSchema = {
	// 	"@context": "https://schema.org",
	// 	"@type": "Product",
	// 	"name": "Simple & Affordable HRAs | Salusion",
	// 	"description": "Salusion streamlines HRA administration for small businesses, delivering affordable, IRS‑compliant, tax‑free health benefits.",
	// 	"brand": {
	// 		"@type": "Brand",
	// 		"name": "Salusion"
	// 	},
	// 	"offers": [
	// 		{
	// 			"@type": "Offer",
	// 			"name": "ICHRA",
	// 			"description": "Individual Coverage Health Reimbursement Arrangement (ICHRA)",
	// 			"price": "14.00",
	// 			"priceCurrency": "USD",
	// 			"availability": "https://schema.org/InStock",
	// 			"priceSpecification": {
	// 				"@type": "UnitPriceSpecification",
	// 				"price": "14.00",
	// 				"priceCurrency": "USD",
	// 				"billingDuration": 1,
	// 				"billingIncrement": 1,
	// 				"unitCode": "MON",
	// 				"unitText": "participant/month",
	// 			},
	// 			"eligibleQuantity": {
	// 				"@type": "QuantitativeValue",
	// 				"value": 1,
	// 				"unitText": "participant"
	// 			},
	// 		},
	// 		{
	// 			"@type": "Offer",
	// 			"name": "QSEHRA",
	// 			"description": "Qualified Small Employer Health Reimbursement Arrangement (QSEHRA)",
	// 			"price": "14.00",
	// 			"priceCurrency": "USD",
	// 			"availability": "https://schema.org/InStock",
	// 			"priceSpecification": {
	// 				"@type": "UnitPriceSpecification",
	// 				"price": "14.00",
	// 				"priceCurrency": "USD",
	// 				"billingDuration": 1,
	// 				"billingIncrement": 1,
	// 				"unitCode": "MON",
	// 				"unitText": "participant/month",
	// 			},
	// 			"eligibleQuantity": {
	// 				"@type": "QuantitativeValue",
	// 				"value": 1,
	// 				"unitText": "participant"
	// 			},
	// 		},
	// 		{
	// 			"@type": "Offer",
	// 			"name": "GCHRA",
	// 			"description": "Group Coverage Health Reimbursement Arrangement (ICHRA)",
	// 			"price": "5.00",
	// 			"priceCurrency": "USD",
	// 			"availability": "https://schema.org/InStock",
	// 			"priceSpecification": {
	// 				"@type": "UnitPriceSpecification",
	// 				"price": "5.00",
	// 				"priceCurrency": "USD",
	// 				"billingDuration": 1,
	// 				"billingIncrement": 1,
	// 				"unitCode": "MON",
	// 				"unitText": "participant/month",
	// 			},
	// 			"eligibleQuantity": {
	// 				"@type": "QuantitativeValue",
	// 				"value": 1,
	// 				"unitText": "participant"
	// 			},
	// 		},
	// 		{
	// 			"@type": "Offer",
	// 			"name": "EBHRA",
	// 			"description": "Excepted Benefit Health Reimbursement Arrangement (ICHRA)",
	// 			"price": "5.00",
	// 			"priceCurrency": "USD",
	// 			"availability": "https://schema.org/InStock",
	// 			"priceSpecification": {
	// 				"@type": "UnitPriceSpecification",
	// 				"price": "5.00",
	// 				"priceCurrency": "USD",
	// 				"billingDuration": 1,
	// 				"billingIncrement": 1,
	// 				"unitCode": "MON",
	// 				"unitText": "participant/month",
	// 			},
	// 			"eligibleQuantity": {
	// 				"@type": "QuantitativeValue",
	// 				"value": 1,
	// 				"unitText": "participant"
	// 			},
	// 		},
	// 	],
	// 	"image": "https://salusion.com/assets/images/Generic.png",
	// 	"url": "https://salusion.com",
	// }

	return (
		<section className="first-section first-padding" id="hero">
			<Helmet>
				{/*<title>Lower the Cost of Healthcare | Salusion</title>
				<meta name="title" content="Lower the Cost of Healthcare | Salusion" />
				<meta name="description" content="Salusion simplifies the administration of tax-advantaged health reimbursement arrangements." />
				<meta name="keywords" content="HRA, Health Reimbursement Arrangement, healthcare costs, tax-advantaged, health benefits, small business HRA, Salusion" />
				<link rel="canonical" href="https://salusion.com" />

				<meta property="og:title" content="Lower the Cost of Healthcare | Salusion" />
				<meta property="og:description" content="Salusion simplifies the administration of tax-advantaged Health Reimbursement Arrangements (HRAs) to help companies lower healthcare costs." />
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://salusion.com/" />
				<meta property="og:image" content="https://salusion.com/assets/images/Generic.png" />
				<meta property="og:image:alt" content="Salusion logo and healthcare savings" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@salusion" />
				<meta name="twitter:title" content="Lower the Cost of Healthcare | Salusion" />
				<meta name="twitter:description" content="Salusion simplifies the administration of tax-advantaged Health Reimbursement Arrangements (HRAs) to help companies lower healthcare costs." />
				<meta name="twitter:image" content="https://salusion.com/assets/images/Generic.png" />

				<script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
				*/}


			</Helmet>

			<div className="container">
				<div className="row align-items-center">
					<div className="col-12 col-md-7">
						<div className="hero-content">
							<h1>Lower the Cost of Healthcare</h1>
							<p>Salusion simplifies the administration of tax-advantaged health reimbursement arrangements</p>

							<Link className="btn-linear" onClick={(event) => toSalusionPrivate(event, "/create-account", false)}>
								Start Your Company's HRA Now
							</Link>
						</div>
					</div>
					<div className="col-12 col-md-5">
						<div className="hero-animation">
							<Lottie animationData={animationHero} loop={false} />
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
